<template>
	<!-- TODO: Consolidate the offset/positioning instead of differentiating for tags and photo annotations -->
	<v-menu
		:close-on-content-click="true"
		z-index="9999"
		:attach="true"
		:offset-overflow="source === 'tag' ? true : false"
		:offset-y="source === 'tag' ? true : false"
		:nudge-top="8"
		:nudge-left="source === 'tag' ? 74 : 0"
		:nudge-right="source === 'annotation' ? 36 : 0"
		:top="source === 'tag' ? true : false"
		transition="scale-transition"
		:origin="source === 'tag' ? 'center center' : ''"
		v-test="`tag-editor-color-picker-menu`">
		<v-card class="color-picker-card elevation-6 pa-2">
			<div class="color-picker ga-1">
				<div
					v-for="(color, index) in colors"
					:key="index"
					class="cursor-pointer scale-transition"
					:style="{ backgroundColor: color }"
					@click="selectColor(color)"
					tile
					v-test="`tag-editor-color-picker-swatch-${color.replace('#', '')}`"
					v-track="`tag-editor-color-picker-swatch-${color.replace('#', '')}`"></div>
			</div>
		</v-card>
		<template v-slot:activator="{ on, attrs }">
			<div
				ref="activator"
				class="activator rounded-circle border-solid scale-transition flex-grow-0 flex-shrink-0"
				:style="{ backgroundColor: selectedColor || getRandomColor() }"
				v-bind="attrs"
				v-on="on"
				v-test="`tag-editor-color-picker-button`"
				v-track="`tag-editor-color-picker-button`"></div>
		</template>
	</v-menu>
</template>
<script lang="ts">
	import { getRandomTagColor } from "@/helpers/tags";
	import { Colors } from "@/types/tags/Colors";
	import { ColorPickerSource } from "@/types/media/ColorPickerSource";
	import { PropType } from "vue";

	export default {
		name: "ColorPicker",
		props: {
			value: {
				type: String,
				default: "",
			},
			source: {
				type: String as PropType<ColorPickerSource>,
				default: "tag",
			},
		},
		data() {
			return {
				selectedColor: this.value,
				colors: Colors,
			};
		},
		beforeMount() {
			if (!this.value) {
				this.selectedColor = this.getRandomColor();
				this.$emit("input", this.selectedColor);
			}
		},
		methods: {
			selectColor(color: string): void {
				this.selectedColor = color;
				this.$emit("input", color);
			},
			getRandomColor(): string {
				this.selectedColor = getRandomTagColor(this.selectedColor);
				this.$emit("input", this.selectedColor);
				return this.selectedColor;
			},
		},
		watch: {
			value(newValue) {
				if (!newValue) {
					this.selectedColor = this.getRandomColor();
				} else {
					this.selectedColor = newValue;
				}
				this.$emit("input", this.selectedColor);
			},
		},
	};
</script>

<style scoped>
	.activator {
		width: 28px;
		height: 28px;
	}

	.color-picker {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		grid-template-rows: repeat(4, 1fr);
		width: 180px;
		height: 180px;
	}
</style>
